import { queryAll, showElement, hideElement } from "./dom.js";

export function initPasswordVisibility() {
    const toggles = queryAll('[data-action="toggle-password"]');
    if (!toggles.length) return;

    toggles.forEach(toggle => {
        toggle.addEventListener("click", () => handleToggle(toggle));
    });
}

function handleToggle(toggle) {
    const inputId = toggle.getAttribute("aria-controls");
    const input = inputId ? document.getElementById(inputId) : null;
    if (!input) return;

    const willShow = input.type === "password";
    input.type = willShow ? "text" : "password";

    toggle.setAttribute("aria-pressed", String(willShow));
    toggle.setAttribute("aria-label", willShow ? "Hide password" : "Show password");

    const showText = toggle.querySelector(".password-toggle__text--show");
    const hideText = toggle.querySelector(".password-toggle__text--hide");
    if (showText && hideText) {
        if (willShow) {
            hideElement(showText);
            showElement(hideText);
        } else {
            showElement(showText);
            hideElement(hideText);
        }
    }
}
